/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Formik, FormikProps } from 'formik';
import FormikErrorFocus from 'formik-error-focus';

import RouteLink from '../../../../shared/components/routeLink';
import AuthInput from '../../components/authInput';
import AuthButton from '../../components/authSubmitButton';
import { enableModal } from '../../../../core/store/app/actions';
import { IModalData, IState } from '../../../../shared/utilities/interfaces';
import { AuthSubtitle, AuthTitle } from '../index.styles';
import { FieldType } from '../../../../shared/utilities/interfaces';
import { getValidation } from '../../../../shared/utilities/validationSchema';
import { AUTH_ACTIONS, loginAction } from '../../store/actions';
import { AccountStatusEnum, LoginFormBody } from 'features/auth/utilites';
import AccountApproval from '../accountApproval';

interface ILogin {
  enableAppModal: (data: IModalData) => void;
  login: (data: LoginFormBody) => void;
  isLoggedIn: boolean;
  accountStatus: string;
};

const LoginFormFields: FieldType[] = [
  {
    field: 'email',
    label: 'Email',
    type: 'text',
    validation: {
      type: 'email',
      length: {
        max: 40,
        min: 0
      },
      required: true
    }
  },
  {
    field: 'password',
    label: 'Password',
    type: 'password',
    validation: {
      type: 'text',
      length: {
        max: 20,
        min: 8
      },
      required: true
    }
  }
];

function Login(
  loginProps: ILogin
) {
  const dispatch = useDispatch();
  const { login, isLoggedIn, accountStatus, enableAppModal } = loginProps;
  const initialValues = {
    email: '', password: ''
  };


  useEffect(() => {
    dispatch({
      type: AUTH_ACTIONS.USERPAYLOAD_SUCCESS,payload:{}
    });
  }, []);

  const onSubmit = async (data: typeof initialValues) => {
    // call api for login
    // enableAppModal({
    //   alertTitle: 'Error',
    //   message: 'this is an error',
    //   severity: 'error',
    //   strongText: 'see here'
    // });
    const response = await login({
      email: data.email,
      password: data.password
    });
  };

  if (isLoggedIn && accountStatus === AccountStatusEnum.PENDING) {
    return (
      <><AccountApproval /></>
    );
  } else {
    return (<div>
      <AuthTitle variant='h4' fontWeight="bold">
        Welcome back!
      </AuthTitle>
      <AuthSubtitle
        variant='body1'
      >
        New User?&nbsp;
      </AuthSubtitle>
      <RouteLink
        to='/auth/signup'
      >
        Create an account
      </RouteLink>
      <Formik
        initialValues={initialValues}
        validationSchema={getValidation(LoginFormFields,"")}
        onSubmit={onSubmit}
        enableReinitialize
        validateOnBlur
      >
        {({ handleSubmit }: FormikProps<typeof initialValues>) => (
          <form onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
            e.preventDefault();
            handleSubmit();
          }}>
            <AuthInput
              variant='standard'
              label='Email'
              name='email'
            />
            <AuthInput
              variant='standard'
              label='Password'
              name='password'
              type='password'
            />
            <RouteLink
              to='/auth/reset-password'
              sx={{ float: 'right' }}
            >
              Forgot Password?
            </RouteLink>
            <AuthButton variant='contained' type='submit'>
              Sign In
            </AuthButton>
            <FormikErrorFocus
              offset={0}
              align="middle"
              focusDelay={10}
              ease="linear"
              duration={500}
            />
          </form>
        )}
      </Formik>
    </div>);
  }
}

export default connect((state: IState) => ({
  isLoggedIn: state.auth.isLoggedIn,
  accountStatus: state.auth.status
}),
  {
    enableAppModal: enableModal,
    login: loginAction
  }
)(Login);
